export const PhotoType = {
  UntaggedPhoto: 0,
  MainPhoto: 1,
  TirePhoto: 2,
  HiddenPhoto: 3,
}
